
    
    import { createRequest, createActionRequest } from '/vercel/path0/node_modules/.pnpm/@modern-js+plugin-data-loader@2.71.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@modern-js/plugin-data-loader/dist/esm/cli/createRequest';
  
    
      export const loader = createRequest('p_(orgSlug)/jobs/(jobId)/stage/page');
    
  